import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { paginateData, calculateTotalPages } from "../../../assets/js/script";
import TableHeader from "../../Common/TableComponent/TableHeader";
import EntriesDropdown from "../../Common/TableComponent/EntriesDropdown";
import TablesRow from "../../Common/TableComponent/TablesRow";
import { Pagination } from "../../Common/TableComponent/Pagination";
import {
  fetchTagCollections,
  deleteTagCollection,
} from "../../../services/tagCollectionService";
import { Loading } from "../../Common/OtherElements/Loading";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { confirmDelete } from "../../Common/OtherElements/confirmDeleteClone";
import { TableDataStatusError } from "../../Common/OtherElements/TableDataStatusError";
import { handleErrors } from "../../../utils/errorHandler";
import { usePageLevelAccess } from "../../../hooks/usePageLevelAccess";
import TagCollectionToggleSwitch from "./TagCollectionToggleSwitch";
import TagCollectionFeaturedToggleSwitch from "./TagCollectionFeaturedToggleSwitch";
import ComponentHeader from "../../Common/OtherElements/ComponentHeader";

const ViewTagCollection = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [manageTags, setmanageTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageAccessDetails, setPageAccessDetails] = useState([]);
  const PageLevelAccessurl = "tag-collection";
  const navigate = useNavigate();
  const { pageAccessData } = usePageLevelAccess(PageLevelAccessurl);

  useEffect(() => {
    if (pageAccessData) {
      if (!pageAccessData.viewAccess) {
        navigate("/404-error-page");
      } else {
        setPageAccessDetails(pageAccessData);
      }
    } else {
      console.log("No page access details found");
    }
  }, [pageAccessData, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await fetchTagCollections();
        if (response.isSuccess) {
          setmanageTags(response.result);
        }
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredData = manageTags.filter((tags) =>
    tags.collectionName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const currentData = paginateData(filteredData, currentPage, entriesPerPage);
  const totalPages = calculateTotalPages(filteredData.length, entriesPerPage);

  const handleEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const handleDelete = async (tagId) => {
    const confirmed = await confirmDelete("tag-collection");
    if (confirmed) {
      try {
        await deleteTagCollection(tagId);
        setmanageTags((prev) => prev.filter((item) => item.id !== tagId));
        Swal.fire(
          "Deleted!",
          "Tag Collection deleted successfully!",
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  const handleStatusChange = (id, newStatus) => {
    setmanageTags((prevProperties) =>
      prevProperties.map((property) =>
        property.id === id ? { ...property, status: newStatus } : property
      )
    );
  };
  return (
    <>
      <ToastContainer />
      <ComponentHeader title="View Tags" />

      {pageAccessDetails.viewAccess ? (
        <div className="row">
          <div className="col-xxl-12">
            <div className="card mt-xxl-n5">
              <div className="card-header">
                <h5 className="mb-sm-2 mt-sm-2">Manage Tag Colections</h5>
              </div>
              <div className="card-body manage-amenity-master-card-body">
                <div className="pagination-details-responsive justify-content-between mb-3">
                  <EntriesDropdown
                    entriesPerPage={entriesPerPage}
                    onEntriesChange={handleEntriesChange}
                    options={[10, 25, 50, 100]}
                  />
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control mb-2"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                {loading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-bordered">
                      <TableHeader
                        columns={[
                          "#",
                          "Collection",
                          "Collection URL",
                          "Published?",
                          "Featured?",
                          "Modified On",
                          "Action",
                        ]}
                      />
                      <tbody className="manage-property-owner-table-values">
                        {currentData.length === 0 ? (
                          <TableDataStatusError colspan="8" />
                        ) : (
                          currentData.map((item, index) => (
                            <TablesRow
                              key={item.id}
                              rowData={{
                                Id:
                                  (currentPage - 1) * entriesPerPage +
                                  index +
                                  1,
                                collectionName: item.collectionName,
                                collectionTagURL: item.collectionTagURL,
                                publishOrUnPublish: (
                                  <TagCollectionToggleSwitch
                                    propId={item.id}
                                    initialStatus={
                                      item.published === true
                                        ? "Published"
                                        : "UnPublished"
                                    }
                                    onStatusChange={(newStatus) =>
                                      handleStatusChange(item.id, newStatus)
                                    }
                                  />
                                ),
                                featuredOrUnFeatured: (
                                  <TagCollectionFeaturedToggleSwitch
                                    propId={item.id}
                                    initialStatus={
                                      item.featured === true
                                        ? "Featured"
                                        : "UnFeatured"
                                    }
                                    onStatusChange={(newStatus) =>
                                      handleStatusChange(item.id, newStatus)
                                    }
                                  />
                                ),
                                tagName: item.tagName,
                                displayOrder: item.displayOrder,
                                modifiedOn: (
                                  <div>
                                    {new Date(item.modifiedOn)
                                      .toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true,
                                      })
                                      .replace(",", "")}
                                    <br />
                                    <span className="text-muted fs-10">
                                      modified by {item.modifiedByUserName}
                                    </span>
                                  </div>
                                ),
                              }}
                              columns={[
                                "Id",
                                "collectionName",
                                "collectionTagURL",
                                "publishOrUnPublish",
                                "featuredOrUnFeatured",
                                "modifiedOn",
                              ]}
                              hideIcons={false}
                              onEdit={() => navigate(`update/${item.id}`)}
                              onDelete={() => handleDelete(item.id)}
                              pageLevelAccessData={pageAccessDetails}
                            />
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalEntries={filteredData.length}
                  entriesPerPage={entriesPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ViewTagCollection;
